import { createAction, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

const experimentDuck = objectDuckCreator({
    store: 'experiment',
    initialState: {
        results: [],
        isLoaded: false,
    },
}).extend({
    types: [
        'SET_EXPERIMENTS',
        'ADD_EXPERIMENT',
        'GET_EXPERIMENTS',
        'GET_EXPERIMENT',
        'CLEAR_EXPERIMENTS',
        'SET_LOADED',
    ],

    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SET_EXPERIMENTS: {
                return {
                    ...state,
                    results: action.payload || [],
                    isLoaded: true,
                };
            }

            case types.ADD_EXPERIMENT: {
                const existingExperimentIndex = state.results.findIndex(
                    (experiment) => experiment === action.payload
                );

                const updatedExperiments = [...state.results];
                if (existingExperimentIndex >= 0) {
                    updatedExperiments[existingExperimentIndex] = action.payload;
                } else {
                    updatedExperiments.push(action.payload);
                }

                return {
                    ...state,
                    results: updatedExperiments,
                };
            }

            case types.GET_EXPERIMENTS: {
                return [
                    ...state.results,
                ];
            }

            case types.CLEAR_EXPERIMENTS: {
                return {
                    ...state,
                    results: [],
                    isLoaded: false,
                };
            }

            default:
                return state;
        }
    },

    creators: ({ types }) => ({
        setExperiments: createAction(types.SET_EXPERIMENTS),
        addExperiment: createAction(types.ADD_EXPERIMENT),
        clearExperiments: createAction(types.CLEAR_EXPERIMENTS),
    }),

    selectors: () => ({
        getExperiments: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).results),
        getIsLoaded: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).isLoaded),
    }),
});

export default experimentDuck;
